export default __webpack_public_path__ + "static/media/round-tick.8aae4325.svg";